<template>
  <div>
    <v-alert type="info" :value="status === 'loading'">{{ $t("global.loading") }}</v-alert>
    <h1>{{ statusTextTitle }}</h1>
    {{ statusTextContent }}
  </div>
</template>

<script>
export default {
  name: "ActionByLinkView",
  data: () => ({
    status: "loading"
  }),
  methods: {},
  created() {
    this.axios
      .get("token/action-by-link/get-action-by-link", {
        params: { token: this.$route.params.token }
      })
      .then(resp => {
        if (resp.data.status === "Token expired") {
          this.status = "tokenExpired";
        } else if (resp.data.status === "Token already utilized") {
          this.status = "tokenUtilized";
        } else {
          this.$router.push("/action-by-link/" + resp.data.view_redirect + "/" + this.$route.params.token);
        }
      })
      .catch(() => {
        this.status = "tokenNotFound";
      });
  },
  computed: {
    statusTextTitle() {
      if (this.status === "loading") {
        return this.$t("actionByLink.loading.title");
      }
      if (this.status === "tokenExpired") {
        return this.$t("actionByLink.tokenExpired.title");
      }
      if (this.status === "tokenUtilized") {
        return this.$t("actionByLink.tokenUtilized.title");
      }
      return this.$t("actionByLink.tokenNotFound.title");
    },
    statusTextContent() {
      if (this.status === "loading") {
        return this.$t("actionByLink.loading.content");
      }
      if (this.status === "tokenExpired") {
        return this.$t("actionByLink.tokenExpired.content");
      }
      if (this.status === "tokenUtilized") {
        return this.$t("actionByLink.tokenUtilized.content");
      }
      return this.$t("actionByLink.tokenNotFound.content");
    }
  }
};
</script>

<style scoped></style>
